export default __webpack_public_path__ + "static/media/single-shadow.3be17bb7.svg";